import { DealerHit } from '@app-types/dealer.types'
import { DealerSearchResult } from '@app-domains/meilisearch/types/dealer-search.types'
import { InstantSearchSearchResult } from '@app-domains/meilisearch/mappers/instantsearch-response.mapper'

type InstantSearchFacets = Record<string, Record<string, number>>

function mapFacets(facets: DealerSearchResult['facets']): InstantSearchFacets {
    const result: InstantSearchFacets = {}
    for (const facet of facets) {
        result[facet.attribute] = facet.values.reduce<Record<string, number>>((acc, item) => {
            acc[item.value] = item.count
            return acc
        }, {})
    }
    return result
}

export function mapDealerSearchResult(
    result: DealerSearchResult,
    indexName: string,
    query: string,
): InstantSearchSearchResult<DealerHit> {
    return {
        hits: result.hits as unknown as DealerHit[],
        nbHits: result.totalHits,
        page: result.page - 1,
        nbPages: result.totalPages,
        hitsPerPage: result.perPage,
        processingTimeMS: result.processingTimeMs,
        exhaustiveNbHits: true,
        exhaustiveFacetsCount: true,
        query,
        params: '',
        index: indexName,
        facets: mapFacets(result.facets),
    }
}
